<div class="position-relative"
     [ngClass]="getBackgroundClass(selectedItemId?.consentStatus)"
     (mouseenter)="thirdPartyConsentMouseOver = true"
     (mouseleave)="thirdPartyConsentMouseOver = false"
     >
     @if (thirdPartyConsentMouseOver && stakeholderName && selectedItemId?.consentStatus !== ThirdPartyConsentStatusEnum.ORAL) {
        <div class="third-party-consent-hover" [ngClass]="{'double-line': stakeholderRemark}">
            <div class="pop-over-triangle"></div>
            <span class="hover-text">{{ stakeholderName }}</span>
            @if(stakeholderRemark){
                <br><span class="hover-text">{{ stakeholderRemark }}</span>
            }
        </div>
    }
    <div class="common-drop-down-arrow common-drop-down" >
        <ng-select
                [clearable]="false"
                [items]="itemsThird"
                (blur)="onSaveModelDropDown()"
                (change)="onSelectedItemIdChange()"
                [(ngModel)]="selectedItemId" class="custom"
                [loading]="loading"
                [searchable]="false"
                (open)="onOpen()"
                [disabled]="consentIsSet()"
                #thirdConsentSelect>
            <ng-template ng-label-tmp let-item="item">
                <div>
                    {{ 'third-consent' | translate }}
                </div>
            </ng-template>

            <ng-template ng-option-tmp let-item="item">
                <div id="wrapper">
                    <div id="left">
                        <div>{{ item.name }}</div>
                    </div>

                    <div id="right">
                        <div *ngIf="item.consentRequest === ThirdPartyConsentStatusEnum.ORAL">
                            <img width='16' height='16' src="/assets/icons/consent/Approx%20Small.svg">
                        </div>
                        <div *ngIf="item.consentRequest === ThirdPartyConsentStatusEnum.MANUALLY">
                            <img width='16' height='16' src="/assets/icons/consent/Refresh%20Medium%20Grey.svg">
                        </div>
                    </div>
                </div>
            </ng-template>
        </ng-select>
    </div>
</div>

